// src/App.jsx
import React, { useState, useEffect, useRef } from 'react';
import './App.css';

function App() {
  const API_BASE = 'https://test-api.itsmyplanetary.me';
  const [status, setStatus] = useState('위치 정보를 불러오는 중...');
  const [coords, setCoords] = useState({ lat: null, lng: null });
  const [address, setAddress] = useState({ road: '', land: '' });
  const [searchedAddress, setSearchedAddress] = useState('');
  const [restaurants, setRestaurants] = useState([]);
  const wrapRef = useRef(null);
  const mapElRef = useRef(null);
  const geocoderRef = useRef(null);

  useEffect(() => {
    const s = document.createElement('script');
    s.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=${process.env.REACT_APP_KAKAO_API_KEY}&libraries=services&autoload=false`;
    s.onload = () => {
      window.kakao.maps.load(() => {
        geocoderRef.current = new window.kakao.maps.services.Geocoder();
        requestLocation();
      });
    };
    document.head.appendChild(s);
    return () => document.head.removeChild(s);
  }, []);

  const requestLocation = () => {
    if (!navigator.geolocation) {
      setStatus('브라우저가 위치 정보를 지원하지 않습니다.');
      return;
    }
    setStatus('위치 정보를 요청합니다...');
    navigator.geolocation.getCurrentPosition(
      ({ coords: { latitude, longitude } }) => {
        setStatus('위치 정보가 허용되었습니다.');
        updateMap(latitude, longitude);
      },
      err => {
        if (err.code === err.PERMISSION_DENIED) {
          setStatus('위치 정보 사용이 거부되었습니다.');
        } else {
          setStatus(`오류 발생: ${err.message}`);
        }
      }
    );
  };

  const updateMap = (lat, lng, roadAddr, landAddr) => {
    setCoords({ lat, lng });
    const container = mapElRef.current;
    container.innerHTML = '';
    container.style.display = 'block';
    const pos = new window.kakao.maps.LatLng(lat, lng);
    new window.kakao.maps.StaticMap(container, {
      center: pos,
      level: 3,
      marker: { position: pos }
    });
    document.getElementById('coords').style.display = 'block';
    if (roadAddr == null && landAddr == null) {
      geocoderRef.current.coord2Address(lng, lat, (res, st) => {
        if (st === window.kakao.maps.services.Status.OK) {
          setAddress({
            road: res[0].road_address?.address_name || '',
            land: res[0].address.address_name
          });
        }
      });
    } else {
      setAddress({ road: roadAddr, land: landAddr });
    }
    document.getElementById('address').style.display = 'block';
  };

  const onSearchClick = () => {
    const wrap = wrapRef.current;
    wrap.style.display = 'block';
    new window.daum.Postcode({
      oncomplete(data) {
        const addr = data.userSelectedType === 'R' ? data.roadAddress : data.jibunAddress;
        const extras = [];
        if (data.userSelectedType === 'R') {
          if (/[동|로|가]$/.test(data.bname)) extras.push(data.bname);
          if (data.buildingName && data.apartment === 'Y') extras.push(data.buildingName);
        }
        const fullAddr = addr + (extras.length ? ` (${extras.join(', ')})` : '');
        setSearchedAddress(fullAddr);
        const resultEl = document.getElementById('resultAddress');
        resultEl.textContent = fullAddr;
        resultEl.style.display = 'block';
        wrap.style.display = 'none';
        geocoderRef.current.addressSearch(fullAddr, (rs, st) => {
          if (st === window.kakao.maps.services.Status.OK) {
            const r = rs[0];
            updateMap(parseFloat(r.y), parseFloat(r.x), addr, r.address.address_name);
          }
        });
      },
      onresize(size) { wrap.style.height = `${size.height}px`; },
      width: '100%',
      height: '100%'
    }).embed(wrap);
  };

  const fetchRestaurants = async () => {
    if (!coords.lat) return;
    const tokenRes = await fetch(`${API_BASE}/token`);
    const { access_token } = await tokenRes.json();
    const url = `https://www.yogiyo.co.kr/api/v2/restaurants?items=60&lat=${coords.lat}&lng=${coords.lng}&order=rank&page=0&search=&serving_type=vd`;
    const res = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${access_token}`,
        'x-apikey': 'iphoneap',
        'x-apisecret': 'fe5183cc3dea12bd0ce299cf110a75a2'
      }
    });
    const json = await res.json();
    setRestaurants(json.restaurants);
  };

  return (
    <div id="app">
      <div style={{ textAlign: 'center', marginBottom: '16px', fontSize: '12px', color: '#666' }}>
        개발자 최승호가 제작했습니다. 코드 무단 사용을 금지합니다.
      </div>
      <div id="status">{status}</div>
      <button id="searchBtn" onClick={onSearchClick}>주소 검색</button>
      <div id="wrap" ref={wrapRef}></div>
      <div id="resultAddress"></div>
      <div id="coords">위도: {coords.lat?.toFixed(6)}, 경도: {coords.lng?.toFixed(6)}</div>
      <div id="address">
        도로명 주소: {address.road}<br />
        지번 주소: {address.land}
      </div>
      <button id="btn-request" onClick={requestLocation}>위치 정보 재요청</button>
      <div id="staticMap" ref={mapElRef}></div>
      <button id="fetchStores" onClick={fetchRestaurants}>매장 검색</button>
      <div className="store-list">
        {restaurants.map(r => (
          <div key={r.id} className="store-card">
            <img src={r.logo_url} alt="" />
            <h3>{r.name}</h3>
            <p>{r.address}</p>
            <p>영업중: {r.is_open ? 'O' : 'X'}</p>
            <p>최소주문금액: {r.min_order_amount}원</p>
            <p>무료배달기준: {r.free_delivery_threshold}원</p>
            <p>배달예정: {r.estimated_delivery_time}</p>
            <p>거리: {r.distance.toFixed(2)}km</p>
            <p>배달비: {r.delivery_fee_to_display.basic}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default App;

